export default {
	"确定":"确定1",
	// 可以以頁面為單位來寫，比如首頁的內容，寫在index字段，個人中心寫在center，共同部分寫在common部分
	common: { //通用
		sure: '確定',
		cancel: '取消',
		tips: '提示',
		about: {
			title: '關於尚捷雲'
		},
		manage: '管理',
		organizational: '組織架構',
		AddEmployee: '添加員工'
	},
	tabbar: {
		work: '工作台',
		communication: '通訊錄',
		my: '我的',
	},
	index: {
		ApplicationCenter: '應用市場',
		ApplicationList: '應用列表',
		console: '控制台',
	},
	communication: {
		invitation: '邀請',
		AdvancedCertification: '高級認證',
		OtherTeams: '其他團隊',
		RegisteredEnterprise: '註冊企業',
		JoinTheEnterprise: '加入企業',
		JoinRequest: '新成員申請',
	},
	my: {
		AccountSecurity: '賬號安全',
		scan: '掃一掃',
		resume: '個人簡歷',
		PlatformAccount: '平台賬號'
	},
	setting: {
		title: '設置',
		general: {
			title: '通用',
			darkMode: '深色模式',
			language: '多語言',
			fontSize: '字體大小',
		},
		myInfo: {
			title: '我的信息'
		},
		SecurityCenter: '安全中心',
		Protected: '已保護',
		Unprotected: '未保護',
		UsersAndFeedback: {
			title: '用戶與反饋'
		},
		Privacy: {
			title: '隱私'
		},
		logout: '退出登錄',
		confirmLogoutTips: '確定要退出當前賬號嗎？ '
	},
	equipment:{
		title:'設備'
	}
}
